<template>
  <div class="kbbb" v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">打印报表</p>
        <div class="rt">
          <el-button
            type="primary"
            @click="scBb"
            v-if="role == 'Z'&&kbxmlc.zt != '2'"
            :disabled="waitLoading"
            >生成报表</el-button
          >
          <el-button @click="packDownload" type="primary"
            >打包下载</el-button
          >
        </div>
      </div>
      <el-table
        ref="table"
        border
        :data="tableData"
        style="width: 100%"
        max-height="570"
        v-loading='waitLoading'
      >
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column
          prop="fileName"
          label="文件名称"
          show-overflow-tooltip
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="docTime"
          label="生成时间"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click='loadBb(scope.row)'>下载</el-button>
            <el-button type="text" @click='lookBb(scope.row)'>查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button
      type="primary lcNext"
      :disabled="!isScbb || waitLoading"
      @click="nextBtn"
      v-if="kbxmlc.zt != '2' && role == 'Z'"
      >开标结束</el-button
    >
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "dybb",//开评一体打印报表
  components: {},
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableData: [],
      isScbb: false, //是否已生成报表
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      lcSteps: JSON.parse(
        sessionStorage.getItem("lcSteps") ? sessionStorage.getItem("lcSteps") : ""
      ),
    };
  },
  created() {
  },
  methods: {
    packDownload() {
      let para = {
        djlcId: this.djlcId,
      };
      this.$api
        .packDownloadReport(para)
        .then((res) => {
          let fileName = "报表.zip";
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    getData() {
      let para = {
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      this.$api
        .getReportFormList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.kbxmlc = res.data.data.reportFormShow.kbxmlc;
            this.tableData = res.data.data.reportFormShow.reportFormList;
            this.isScbb=res.data.data.reportFormShow.reportFormFlag;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //生成报表
    scBb() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .scKpytKbjlb(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "报表生成成功！",
            });
            this.getData()
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //下载报表
    loadBb(row) {
      if (this.waitLoading) return false;
      let para = {
        id: row.docFileId,
      };
      this.waitLoading = true;
      this.$api
        .loadBb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //查看报表
    lookBb(row){
      this.$api
        .pdfshow({
          bidfilesId: row.pdfBizFileId,
        })
        .then((res) => {
          const blob = new Blob([res.data], {
          type: "application/pdf;chartset=UTF-8",
        });
         const url = window.URL.createObjectURL(blob); // 创建下载的链接
         window.open(url)
        })
        .catch((err) => {
          this.$message({
            message: err.statusText,
            type: "error",
          });
        });
    },
    nextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
        isOver:true
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
  beforeDestroy() {
  },
};
</script>
<style lang="less">
.kbbb {
  .dialogBox {
    padding: 50px 80px;
    span {
      font-size: 16px;
      color: #333;
      margin-right: 10px;
    }
    .el-input__inner {
      padding: 0 0 0 15px;
    }
  }
  span > .el-button.show {
    margin-left: 10px;
    background: @base-color;
    color: #fff;
  }
  span > .el-button.show:hover,
  span > .el-button.show:focus {
    background: fade(@base-color, 80%);
    color: #fff;
  }
  span > .el-button,
  span > .el-button:hover,
  span > .el-button:focus {
    background: #ccc;
    margin-left: 10px;
    color: #fff;
  }
  .el-button--primary.is-disabled.djsBtn {
    color: #d70a30;
    font-size: 18px;
  }
}
.el-popover.kbbbPop {
  min-width: 100px;
  padding: 0px;
  border: 1px solid @base-color;
  background: @bg;
  .loadBtns {
    li {
      list-style: none;
      height: 35px;
      line-height: 35px;
      color: @base-color;
      padding: 0 12px;
      cursor: pointer;
    }
    li + li {
      border-top: 1px solid @base-color;
    }
  }
}

.el-popper[x-placement^="bottom"].kbbbPop .popper__arrow {
  border-bottom-color: @base-color;
}
.el-popper[x-placement^="bottom"].kbbbPop .popper__arrow::after {
  border-bottom-color: @bg;
}
.el-dialog__body {
  height: 100%;
  .pdf {
    height: calc(~"100% - 60px");
    margin-bottom: 10px;
  }
}
</style>